import React, {useState, useContext, useEffect} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {PostUsuari} from "../../../dao/root/PostUsuari";
import {User} from "../../../model/root/User";
import {AuthContext} from "../../../config/AuthContext";
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';
import Empresa from '../../../model/admin/Empresa';

const { Option } = Select;
interface IngredientModalProps {
    element: User;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const UsuariModal: React.FC<IngredientModalProps> = ({element, visible, onClose, editar}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [empresas, setDadesEmpresa] = useState<any[]>([]);

    useEffect(() => {
        if (visible) {
            checkDades();
        }
    }, [visible]);
    async function checkDades() {
        // Obtener empresas
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
    }

    async function handleSubmit() {
        const nom = await form.getFieldValue('nom');
        const id = await form.getFieldValue('id');
        const pass = await form.getFieldValue('password');
        const empresa = await form.getFieldValue('empresa');
        await PostUsuari(id, nom, pass, empresa, userId);
        onClose(true);
    };

    async function handleCancel() {
        onClose(false); 
    };

    return (
        <Modal
            title="Crear/Editar Usuari"
            open={visible}
            onCancel={handleCancel}
            width={'50%'}
            footer={[
            ]}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit} >
                <br/>
                    <Form.Item 
                        label="Empresa" 
                        name="empresa" 
                        rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                    >
                        <Select
                            disabled={!editar}
                            placeholder="Selecciona una empresa"
                        >
                            {Array.isArray(empresas) && empresas.map(value =>
                                <Option key={value.id} value={value.datasource}>
                                    {value.nomEmpresa}
                                </Option>
                            )}
                        </Select>      
                    </Form.Item>
                    
                    <Row  gutter={[16, 16]}>
                        <Col span={3}>
                            <Form.Item label="id" name="id">
                                <Input type="text" disabled={true}/>
                            </Form.Item>
                        </Col>
                        <Col flex="auto">
                            <Form.Item label="nom" name="nom"
                                    rules={[{ required: true, message: 'Introdueix el nom d\'usuari' }]}>
                                <Input type="text"/>
                            </Form.Item>
                        </Col>
                        <Col flex="auto">
                            <Form.Item label="passwrod" name="password"
                                    rules={[{ required: true, message: 'Introdueix un password' }]}>
                                <Input type="password"/>
                            </Form.Item>
                        </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            
            </Form>
        </Modal>
    );
};

export default UsuariModal;
